module.exports = __webpack_public_path__ + "img/badge_gray_ms-finaid.72188c51.svg";